// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  selectedTransaction: null,
  tags: {},
  nextCursor: null,
  hasMore: false,
};

const transactions = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_TRANSACTIONS':
      return {
        ...state,
        data: action.append ? [...state.data, ...action.data] : action.data,
        totalCount: action.totalCount,
        filteredCount: action.filteredCount,
        nextCursor: action.nextCursor ?? null,
        hasMore: typeof action.hasMore === 'boolean' ? action.hasMore : false,
        params: action.params,
      };
    case 'GET_TRANSACTION':
      return { ...state, selectedTransaction: action.selectedTransaction };
    // case 'ADD_ORDER_NOTE':
    //   return { ...state, createdOrders: action.createdOrders };
    // case 'UPDATE_ORDER_NOTE':
    //   return { ...state };
    // case 'DELETE_ORDER_NOTE':
    //   return { ...state };
    default:
      return { ...state };
  }
};

export default transactions;